import { connect } from 'react-redux'
import { schedulerActions, metadataActions } from '../../../modules/Instrument'

export const mapState = state => {
  const instrument = state?.instrumentReducer?.instrument || {}
  const schedule = instrument?.metadata?.schedule
  return {
    ...(schedule && typeof schedule === 'object' && !Array.isArray(schedule) ? schedule : {}),
    errors: state?.instrumentReducer?.errors || {},
  }
}

export default component => connect(mapState, { ...schedulerActions, ...metadataActions })(component)
